import { ElButton, ElInput, ElMessage, ElMessageBox } from "element-plus";
import "element-plus/dist/index.css";

export default {
    install(app) {
        // 注册常用组件
        app.component("ElButton", ElButton);
        app.component("ElInput", ElInput);

        // 把 ElMessage 和 ElMessageBox 挂到全局
        app.config.globalProperties.$message = ElMessage;
        app.config.globalProperties.$msgbox = ElMessageBox;
    },
};
